<template>
  <div id="select-box-container">
    <div class="select-box" v-for="(brand, index) in brands" :key="`selected-brand-${index}`">
      <span>{{ `${brand.name}: ${brand.size}` }}</span>
      <span class="close" @click="removeBrand(index)">&times;</span>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: "SelectedBrands",

  computed: {
    ...mapState('userSelections', ['brands']),
  },

  methods: {
    removeBrand(index) {
      this.$store.commit('userSelections/removeBrand', index);
    },
  },
};
</script>
